export default "__VITE_ASSET__C3Y8ePfT__"